<form [formGroup]="form" *ngIf="field">
  <label class="label-form-control">
    Display label
    <capra-icon
      icon="icon-info-outline"
      class="info-icon"
      capraTooltip
      [tooltipContent]="tooltipContent"
      [tooltipInteractive]="false"
      [tooltipDelay]="[750, 0]"
      tooltipPlacement="bottom"
    ></capra-icon>
    <input
      class="form-control form-control-sm text-form-control"
      type="text"
      formControlName="text"
      [placeholder]="field.displayName"
      (keydown.enter)="$event.target.blur()"
    />
  </label>
</form>
